module.exports = __webpack_public_path__ + "media/images/lb/473-bfcd4e7febb56425127b432b04ec2c87.svg";